export default __webpack_public_path__ + "static/media/high-capacity-solution.86358f07.png";